import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { getOrganizationViewUrl } from '../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../utils/routing/reactRoute'

export const getEInvoicesUrl = (organization?: Organization) => {
  return `${getOrganizationViewUrl(organization?.url, reactRoute.organization.uploads.getMainRoute())}?type=EDocument`
}
